/*
  Julery – Louis Vuitton Datecode-Checker
  Erwartet im Artikel: #code-checker mit #user-code (Input), #check-code (Button), #result.
  Formate:
    ca. 1980–1989: 3–4 Ziffern (JJM oder JJMM), ab Mitte der 80er gefolgt von 2 Buchstaben (Fabrik)
    1990–2006:     2–3 Buchstaben + 4 Ziffern; Ziffer 1+3 = Monat, Ziffer 2+4 = Jahr
    ab 2007:       2–3 Buchstaben + 4 Ziffern; Ziffer 1+3 = Kalenderwoche, Ziffer 2+4 = Jahr
    ab März 2021:  meist Chip statt Datecode; kleine Modelle (z. B. Mini Pochette, Nano Speedy) tragen weiter Codes im Wochenformat
  Ein plausibler Code ist KEIN Echtheitsbeweis – Faelschungen kopieren echte Codes.
*/
document.addEventListener("DOMContentLoaded", function () {
  var box = document.getElementById("code-checker");
  var input = document.getElementById("user-code");
  var button = document.getElementById("check-code");
  var result = document.getElementById("result");
  if (!box || !input || !button || !result) return;

  var lang = (document.documentElement.lang || "de").slice(0, 2).toLowerCase();
  if (lang !== "en" && lang !== "nl") lang = "de";
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  var T = {
    de: {
      months: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
      empty: "Bitte geben Sie den Datecode ein, z. B. SD1027.",
      ok: "Der Code ist formal plausibel",
      bad: "Der Code passt zu keinem bekannten Louis-Vuitton-Format",
      made: "Hergestellt",
      monthYear: function (m, y) { return m + " " + y; },
      week: function (w, y) { return w + ". Kalenderwoche " + y; },
      factory: "Fabrik",
      unknownFactory: "Code nicht in unserer Liste. Das kann ein seltener Code sein, ist aber auch ein mögliches Warnsignal.",
      or: " oder ",
      noFactory: "ohne Fabrikangabe (typisch für frühe 1980er)",
      chipNote: "Seit März 2021 haben die meisten Louis-Vuitton-Taschen einen Chip statt Datecode. Kleine Modelle wie Mini Pochette Accessoires oder Nano Speedy tragen weiterhin einen Datecode in diesem Format.",
      madeIn: "Welches Land es ist, steht auf dem Prägestempel „Made in …“ in der Tasche.",
      reasons: {
        format: "Erwartet werden z. B. „SD1027“ (Buchstaben + 4 Ziffern) oder bei Vintage „8810AR“ bzw. „826“.",
        month: "Monat bzw. Kalenderwoche im Code ist nicht möglich.",
        year: "Dieses Jahr passt nicht zu Louis-Vuitton-Datecodes (ab 1980).",
        future: "Dieses Datum liegt in der Zukunft.",
        week53: "Dieses Jahr hatte keine 53. Kalenderwoche."
      },
      warn: "Wichtig: Ein plausibler Datecode ist kein Echtheitsbeweis. Fälschungen kopieren echte Codes.",
      cta: "Echtheit online prüfen lassen",
      check: "Prüfen",
      placeholder: "z. B. SD1027"
    },
    en: {
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      empty: "Please enter the date code, e.g. SD1027.",
      ok: "The code is formally plausible",
      bad: "The code does not match any known Louis Vuitton format",
      made: "Made",
      monthYear: function (m, y) { return m + " " + y; },
      week: function (w, y) { return "week " + w + " of " + y; },
      factory: "Factory",
      unknownFactory: "Code not in our list. This may be a rare code, but it can also be a warning sign.",
      or: " or ",
      noFactory: "no factory given (typical for the early 1980s)",
      chipNote: "Since March 2021 most Louis Vuitton bags have a chip instead of a date code. Small models such as the Mini Pochette Accessoires or Nano Speedy still carry a date code in this format.",
      madeIn: "Which country it is can be seen on the “Made in …” heat stamp inside the bag.",
      reasons: {
        format: "Expected e.g. “SD1027” (letters + 4 digits) or, for vintage pieces, “8810AR” or “826”.",
        month: "The month or week in the code is not possible.",
        year: "This year does not fit Louis Vuitton date codes (from 1980).",
        future: "This date lies in the future.",
        week53: "This year did not have a week 53."
      },
      warn: "Important: a plausible date code is not proof of authenticity. Counterfeits copy real codes.",
      cta: "Get it authenticated online",
      check: "Check",
      placeholder: "e.g. SD1027"
    },
    nl: {
      months: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"],
      empty: "Voer de datumcode in, bijv. SD1027.",
      ok: "De code is formeel plausibel",
      bad: "De code past bij geen bekend Louis Vuitton-formaat",
      made: "Gemaakt",
      monthYear: function (m, y) { return m + " " + y; },
      week: function (w, y) { return "week " + w + " van " + y; },
      factory: "Fabriek",
      unknownFactory: "Code staat niet in onze lijst. Dit kan een zeldzame code zijn, maar ook een waarschuwingssignaal.",
      or: " of ",
      noFactory: "zonder fabrieksaanduiding (typisch voor begin jaren 80)",
      chipNote: "Sinds maart 2021 hebben de meeste Louis Vuitton-tassen een chip in plaats van een datumcode. Kleine modellen zoals de Mini Pochette Accessoires of Nano Speedy hebben nog steeds een datumcode in dit formaat.",
      madeIn: "Welk land het is, staat op het stempel „Made in …“ in de tas.",
      reasons: {
        format: "Verwacht wordt bijv. „SD1027“ (letters + 4 cijfers) of bij vintage „8810AR“ of „826“.",
        month: "De maand of week in de code is niet mogelijk.",
        year: "Dit jaar past niet bij Louis Vuitton-datumcodes (vanaf 1980).",
        future: "Deze datum ligt in de toekomst.",
        week53: "Dit jaar had geen week 53."
      },
      warn: "Belangrijk: een plausibele datumcode is geen bewijs van echtheid. Namaak kopieert echte codes.",
      cta: "Echtheid online laten controleren",
      check: "Controleren",
      placeholder: "bijv. SD1027"
    }
  }[lang];

  var COUNTRY = {
    de: { DE: "Deutschland", FR: "Frankreich", IT: "Italien", CH: "Schweiz", ES: "Spanien", US: "USA" },
    en: { DE: "Germany", FR: "France", IT: "Italy", CH: "Switzerland", ES: "Spain", US: "USA" },
    nl: { DE: "Duitsland", FR: "Frankrijk", IT: "Italië", CH: "Zwitserland", ES: "Spanje", US: "VS" }
  }[lang];

  // Fabrikcodes (entspricht der Tabelle im Artikel); mehrfach vergebene Codes behalten alle Laender
  var FACTORIES = {};
  function addCodes(country, codes) {
    codes.split(" ").forEach(function (c) {
      FACTORIES[c] = FACTORIES[c] || [];
      if (FACTORIES[c].indexOf(country) === -1) FACTORIES[c].push(country);
    });
  }
  addCodes("DE", "LP OL");
  addCodes("FR", "A0 A1 A2 AA AAS AH AN AR AS BA BJ BU DR DU DT CO CT CX ET FL LA LW MB ML MI NO RA RI SA SD SF SL SN SP SR TA TJ TH TN TR TS VI VX");
  addCodes("IT", "BC BO CE FN FO MA NZ OB PL RC RE SA TD");
  addCodes("CH", "DI FA");
  addCodes("ES", "CA UB LO LB LM LW GI");
  addCodes("US", "FC FH LA OS SD FL TX");

  // Jahre ab 2007 mit 53 Kalenderwochen (ISO 8601)
  var WEEK53 = { 2009: true, 2015: true, 2020: true, 2026: true, 2032: true };

  // Heutiges Jahr und ISO-Kalenderwoche (Codes aus der Zukunft sind unmoeglich)
  var NOW = new Date();
  var NOW_YEAR = NOW.getFullYear();
  function isoWeek(d) {
    var t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    var day = t.getUTCDay() || 7;
    t.setUTCDate(t.getUTCDate() + 4 - day);
    var y0 = new Date(Date.UTC(t.getUTCFullYear(), 0, 1));
    return Math.ceil(((t - y0) / 86400000 + 1) / 7);
  }
  var NOW_WEEK = isoWeek(NOW);

  function factoryText(code) {
    if (!code) return T.noFactory;
    var list = FACTORIES[code];
    if (!list) return null;
    return code + " – " + list.map(function (c) { return COUNTRY[c]; }).join(T.or);
  }

  function analyse(raw) {
    var code = String(raw || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
    if (!code) return { empty: true };

    // Vintage 1980er: JJM / JJMM, optional 2 Buchstaben
    var pre = code.match(/^(\d{2})(\d{1,2})([A-Z]{2})?$/);
    if (pre) {
      var y = 1900 + parseInt(pre[1], 10);
      var m = parseInt(pre[2], 10);
      if (y < 1980 || y > 1989) return { ok: false, code: code, reason: T.reasons.year };
      if (m < 1 || m > 12) return { ok: false, code: code, reason: T.reasons.month };
      return { ok: true, code: code, date: T.monthYear(T.months[m - 1], y), factory: pre[3] || "" };
    }

    // 1990–2021: 2–3 Buchstaben + 4 Ziffern
    var post = code.match(/^([A-Z]{2,3})(\d)(\d)(\d)(\d)$/);
    if (!post) return { ok: false, code: code, reason: T.reasons.format };
    var first = parseInt(post[2] + post[4], 10);   // Ziffer 1 + 3
    var yy = parseInt(post[3] + post[5], 10);      // Ziffer 2 + 4
    var factory = post[1];

    if (yy >= 90 || yy <= 6) {
      var year = yy >= 90 ? 1900 + yy : 2000 + yy;
      if (first < 1 || first > 12) return { ok: false, code: code, reason: T.reasons.month };
      return { ok: true, code: code, date: T.monthYear(T.months[first - 1], year), factory: factory };
    }
    if (yy >= 7 && 2000 + yy <= NOW_YEAR) {
      var wy = 2000 + yy;
      if (first < 1 || first > 53) return { ok: false, code: code, reason: T.reasons.month };
      if (first === 53 && !WEEK53[wy]) return { ok: false, code: code, reason: T.reasons.week53 };
      if (wy === NOW_YEAR && first > NOW_WEEK) return { ok: false, code: code, reason: T.reasons.future };
      return { ok: true, code: code, date: T.week(first, wy), factory: factory, chip: wy >= 2021 };
    }
    return { ok: false, code: code, reason: T.reasons.year };
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; });
  }

  function render(r) {
    if (r.empty) {
      result.innerHTML = '<p class="jdc-msg">' + esc(T.empty) + "</p>";
      return;
    }
    var html = "";
    if (r.ok) {
      var ft = factoryText(r.factory);
      html += '<div class="jdc-status jdc-status--ok">' + esc(T.ok) + "</div>";
      html += '<dl class="jdc-facts">';
      html += "<div><dt>" + esc(T.made) + "</dt><dd>" + esc(r.date) + "</dd></div>";
      html += "<div><dt>" + esc(T.factory) + "</dt><dd>" + esc(ft || r.factory) + "</dd></div>";
      html += "</dl>";
      if (!ft) html += '<p class="jdc-note">' + esc(T.unknownFactory) + "</p>";
      if (r.factory && FACTORIES[r.factory] && FACTORIES[r.factory].length > 1) html += '<p class="jdc-note">' + esc(T.madeIn) + "</p>";
    } else {
      html += '<div class="jdc-status jdc-status--bad">' + esc(T.bad) + "</div>";
      html += '<p class="jdc-note">' + esc(r.reason) + "</p>";
    }
    if (r.chip) html += '<p class="jdc-note">' + esc(T.chipNote) + "</p>";
    html += '<p class="jdc-warn">' + esc(T.warn) + "</p>";
    html += '<a class="jdc-cta" href="' + root.replace(/\/$/, "") + '/products/digitale-echtheitsprufung-handtasche">' + esc(T.cta) + " &rarr;</a>";
    result.innerHTML = html;
  }

  // Aufbau & Styles (bewusst hoehere Spezifitaet als alte Inline-Styles im Artikel)
  if (result.tagName !== "DIV") {
    var div = document.createElement("div");
    div.id = "result";
    result.parentNode.replaceChild(div, result);
    result = div;
  }
  box.classList.add("jdc");
  result.setAttribute("aria-live", "polite");
  input.setAttribute("autocomplete", "off");
  input.setAttribute("autocapitalize", "characters");
  input.setAttribute("spellcheck", "false");
  input.setAttribute("maxlength", "10");
  input.setAttribute("placeholder", T.placeholder);
  button.setAttribute("type", "button");
  button.textContent = T.check;
  var row = document.createElement("div");
  row.className = "jdc-row";
  input.parentNode.insertBefore(row, input);
  row.appendChild(input);
  row.appendChild(button);

  var css = [
    "#code-checker.jdc{--jdc-ink:#1a1a1a;--jdc-matcha:#5F6D57;--jdc-line:rgba(26,26,26,.14);text-align:left;margin:4rem 0;padding:2.4rem 2rem;background:#FDFCF8;border:1px solid var(--jdc-line);border-radius:0}",
    "#code-checker.jdc h2{font-family:'Playfair Display',var(--font-heading-family),serif;font-weight:400;font-size:2.4rem;line-height:1.2;margin:0 0 1.4rem;color:var(--jdc-ink)}",
    "#code-checker.jdc label{font-family:'Montserrat',var(--font-body-family),sans-serif;font-size:1.05rem!important;font-weight:500;letter-spacing:.2em;text-transform:uppercase;color:var(--jdc-matcha);margin:0 0 1rem!important}",
    "#code-checker.jdc .jdc-row{display:flex;flex-direction:column;gap:1rem}",
    "#code-checker.jdc #user-code{width:100%;box-sizing:border-box;height:5rem;padding:0 1.6rem;font-size:1.6rem;letter-spacing:.14em;text-transform:uppercase;color:var(--jdc-ink);background:#fff;border:1px solid rgba(26,26,26,.28);border-radius:0;margin:0}",
    "#code-checker.jdc #user-code:focus{outline:none;border-color:var(--jdc-ink)}",
    "#code-checker.jdc #check-code{height:5rem;margin:0;padding:0 2.8rem;font-family:'Montserrat',var(--font-body-family),sans-serif;font-size:1.2rem;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:#FDFCF8;background:var(--jdc-ink);border:1px solid var(--jdc-ink);border-radius:0;cursor:pointer;transition:background .2s,border-color .2s}",
    "#code-checker.jdc #check-code:hover,#code-checker.jdc #check-code:focus-visible{background:var(--jdc-matcha);border-color:var(--jdc-matcha)}",
    "#code-checker.jdc #result{margin:0;font-size:1.4rem;font-weight:400;color:var(--jdc-ink)}",
    "#code-checker.jdc #result:not(:empty){margin-top:2.4rem;padding-top:2rem;border-top:1px solid var(--jdc-line)}",
    "#code-checker.jdc .jdc-status{font-family:'Playfair Display',var(--font-heading-family),serif!important;font-style:italic;font-size:1.9rem;line-height:1.3;margin:0 0 1.4rem}",
    "#code-checker.jdc .jdc-status--ok{color:var(--jdc-matcha)}",
    "#code-checker.jdc .jdc-status--bad{color:#7a2e2e}",
    "#code-checker.jdc .jdc-facts{margin:0 0 1.4rem;display:grid;gap:.8rem}",
    "#code-checker.jdc .jdc-facts div{display:grid;grid-template-columns:9rem 1fr;gap:1.2rem}",
    "#code-checker.jdc .jdc-facts dt{font-size:1.05rem;font-weight:500;letter-spacing:.16em;text-transform:uppercase;color:rgba(26,26,26,.55);padding-top:.25rem}",
    "#code-checker.jdc .jdc-facts dd{margin:0;font-size:1.5rem;color:var(--jdc-ink)}",
    "#code-checker.jdc .jdc-msg,#code-checker.jdc .jdc-note{font-size:1.35rem;line-height:1.6;color:rgba(26,26,26,.68);margin:0 0 1rem}",
    "#code-checker.jdc .jdc-warn{font-size:1.35rem;line-height:1.6;color:var(--jdc-ink);margin:1.6rem 0 1.6rem;padding-left:1.4rem;border-left:1px solid var(--jdc-matcha)}",
    "#code-checker.jdc .jdc-cta{display:inline-block;font-size:1.1rem;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--jdc-ink);text-decoration:none;border-bottom:1px solid var(--jdc-ink);padding-bottom:.4rem}",
    "#code-checker.jdc .jdc-cta:hover{color:var(--jdc-matcha);border-color:var(--jdc-matcha)}",
    "@media screen and (min-width:750px){#code-checker.jdc{padding:3.6rem 4rem}#code-checker.jdc h2{font-size:2.8rem}#code-checker.jdc .jdc-row{flex-direction:row}#code-checker.jdc #user-code{flex:1}}"
  ].join("");
  var style = document.createElement("style");
  style.textContent = css;
  document.head.appendChild(style);

  function run() { render(analyse(input.value)); }
  button.addEventListener("click", run);
  input.addEventListener("keydown", function (e) {
    if (e.key === "Enter") { e.preventDefault(); run(); }
  });
});
